import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  visible: false,
  data: {} // contains { type, message }
}

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    showToast: (state, action) => {
      state.visible = true
      state.data = action.payload // { type, message }
    },
    hideToast: state => {
      state.visible = false
    }
  }
})

export const { showToast, hideToast } = toastSlice.actions
export default toastSlice.reducer
